import { HsVector2 } from '../../math-new/objects/vector2.class';
import { HsVector3 } from '../../math-new/objects/vector3.class';
import { HsToolsConstants } from '../tools-constants.constants';
import { HsControlActionType } from './control-action-type.enum';
import { HsControlAction } from './control-action.abstract';

/**
 * Multiplicative zoom toward a screen point, for example from a pinch gesture.
 *
 * `scale` is the factor by which the apparent size of the content under `position` should grow
 * (the ratio of the new to the old finger distance for a pinch). Camera tools move by a fraction of the
 * distance to `pivot`, the world point under `position`, or of `fallbackDistance` when no pivot is known.
 */
export class HsZoomControlAction extends HsControlAction {
  public readonly actionType: HsControlActionType = HsControlActionType.Zoom;
  public pivot: HsVector3 | null;

  readonly #pivotValue: HsVector3 = HsVector3.makeZeroVector();

  constructor(
    public position: HsVector2 = new HsVector2(0, 0),
    public scale: number = 1,
    pivot: HsVector3 | null = null,
    public fallbackDistance: number = HsToolsConstants.ZOOM_FALLBACK_DISTANCE,
    public minDistance: number = HsToolsConstants.ZOOM_MIN_DISTANCE
  ) {
    super();
    this.pivot = pivot;
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsZoomControlAction) || !(controlAction.scale > 0)) {
      return;
    }

    // Several pinch events per frame compose multiplicatively, like the finger distance ratios they come from.
    this.scale = (this.isActive ? this.scale : 1) * controlAction.scale;
    this.position.copy(controlAction.position);
    this.pivot = controlAction.pivot === null ? null : this.#pivotValue.copy(controlAction.pivot);
    this.fallbackDistance = controlAction.fallbackDistance;
    this.minDistance = controlAction.minDistance;
    this.isActive = this.scale !== 1;
  }
}
